/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailActivityStatus model module.
 * @module model/EmailActivityStatus
 * @version 1.0.0
 */
export class EmailActivityStatus {
  /**
   * Constructs a new <code>EmailActivityStatus</code>.
   * @alias module:model/EmailActivityStatus
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailActivityStatus</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailActivityStatus} obj Optional instance to populate.
   * @return {module:model/EmailActivityStatus} The populated <code>EmailActivityStatus</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailActivityStatus();
      if (data.hasOwnProperty('state'))
        obj.state = ApiClient.convertToType(data['state'], 'String');
      if (data.hasOwnProperty('date'))
        obj.date = ApiClient.convertToType(data['date'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */
EmailActivityStatus.StateEnum = {
  /**
   * value: "allowed"
   * @const
   */
  allowed: "allowed",

  /**
   * value: "subscribed"
   * @const
   */
  subscribed: "subscribed",

  /**
   * value: "unsubscribed"
   * @const
   */
  unsubscribed: "unsubscribed",

  /**
   * value: "hardBounced"
   * @const
   */
  hardBounced: "hardBounced",

  /**
   * value: "complained"
   * @const
   */
  complained: "complained",

  /**
   * value: "screamed"
   * @const
   */
  screamed: "screamed"
};
/**
 * @member {module:model/EmailActivityStatus.StateEnum} state
 */
EmailActivityStatus.prototype.state = undefined;

/**
 * @member {String} date
 */
EmailActivityStatus.prototype.date = undefined;

